module.exports = __webpack_public_path__ + "assets/9dfbb758a620453552c5b5dcd8a0ad52.png";